import React, { useContext } from 'react';
import styled from 'styled-components';
import { IThemeLogoPlacements, IThemeLogoVariant } from '../../themes/theme';
import { IGutterProps, useGutterCss } from '../../fundamentals/spaces/space';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { useActionCss } from '../../fundamentals/actions';
import { EoraAssetsContext } from '../../themes/EoraThemeProvider';
import { BaseImg } from '../../common/BaseElements';

export type LogoSize =
  | typeof SIZES.MICRO
  | typeof SIZES.XXX_SMALL
  | typeof SIZES.XX_SMALL
  | typeof SIZES.X_SMALL
  | typeof SIZES.SMALL
  | typeof SIZES.MEDIUM
  | typeof SIZES.LARGE
  | typeof SIZES.X_LARGE;

export interface ILogoProps extends React.ImgHTMLAttributes<HTMLImageElement>, IGutterProps {
  placement?: keyof IThemeLogoPlacements;
  size?: LogoSize;
  variant?: keyof IThemeLogoVariant;
}

export const Logo = styled(BaseImg).attrs<ILogoProps>(({ placement = 'header', variant, theme, src, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Logo');
  const { baseAssetsUrl } = useContext(EoraAssetsContext);
  if (!variant) {
    variant = theme.isDarkMode ? 'white' : 'color';
  }

  return {
    src: src ?? `${baseAssetsUrl}${theme.logos[placement]?.[variant] ?? theme.logos[placement]?.color}`,
    ...generateTestId()
  };
})<ILogoProps>`
  height: ${({ theme, size = SIZES.MEDIUM }) => theme.sizes[size]};
  ${useActionCss};
  ${useGutterCss()};
`;
